<a class="sharing-link">
    <img src="assets/images/icons/share-white.png" class="cursor-pointer opensharelink" alt="" (click)="openShareLink()">
    <div class="sharelink uk-flex">
        <share-buttons [theme]="'default'" [include]="['facebook','twitter','telegram','whatsapp','sms','email']" [show]="9" [size]="1" [url]="pageURL" [image]="pageFeaturedImage" [autoSetMeta]="false"></share-buttons>
    </div>
</a>